import {
  setPublicTourStatus,
  savePublicTourPayload,
  setDone,
} from './publicTourActions';

import { savePublicTourLang } from './translationsActions';
import {
  fetchTourPreview as _fetchTourPreview,
  fetchAvailableLanguages as _fetchAvailableLanguages,
} from '../api/v2/previewTour';

export const fetchPreviewTour = (tourId, lang = 'en') => {
  return async dispatch => {
    try {
      dispatch(setPublicTourStatus({ status: 'loading' }));
      const previewTour = await _fetchTourPreview(tourId, lang);
      dispatch(savePublicTourPayload(previewTour));
    } catch (e) {
      console.error(e);
    } finally {
      dispatch(setDone());
    }
  };
};

export const fetchAvailableLanguages = tourId => {
  return async dispatch => {
    try {
      const previewTour = await _fetchAvailableLanguages(tourId);
      dispatch(savePublicTourLang(previewTour));
    } catch (e) {
      console.error(e);
    }
  };
};
